import { combineReducers } from 'redux';


import templateReducer from './reducer_template';
import childrenReducer from './reducer_children';
import tabReducer from './reducer_tabs';
import modalReducer from './reducer_modal';
import statusReducer from './reducer_status';


const hotkeyTempateReducer = combineReducers({
  template: templateReducer,
  children: childrenReducer,
  tabs    : tabReducer,
  modal   : modalReducer,
  status  : statusReducer
});


export default hotkeyTempateReducer;
